import { render } from "./EmailsPage.vue?vue&type=template&id=16ed3c18&ts=true"
import script from "./EmailsPage.vue?vue&type=script&lang=ts"
export * from "./EmailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__